export enum EDragDropItemsIds {
  DefaultBlockCdkDragListItems = 'DefaultBlockCdkDragListItems',
  DefaultFieldListListItems = 'DefaultFieldListListItems',
  MainBuilderFieldTypesListItems = 'MainBuilderFieldTypesListItems',
  MainBuilderWidgetsListItems = 'MainBuilderWidgetsListItems',
}
